import React from 'react';
import { Link } from 'react-router-dom'
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles, withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import classnames from 'classnames';

// Contexts
import { withNavigation, withTranslate } from '../../../core/TenantProvider';
// Components - Atoms, Organisms,Containers
import APLogo from '../../atoms/APLogo';
import APButton from '../../atoms/APButton';
import APContactSection from '../APContactSection';
import APContactSectionClosed from '../APContactSectionClosed';
import ListItemLink from './ListItemLink';
// Files in the same folder
import { ReactComponent as CollapseIcon } from './assets/icons/collapseIcon.svg';
import { ReactComponent as ExpandIcon } from './assets/icons/expandIcon.svg';
import { ReactComponent as CloseIcon } from './assets/icons/closeIcon.svg';
import { ReactComponent as BurgerIcon } from './assets/icons/burgerIcon.svg';

import APSlidingMenuStyles from './styles/APSlidingMenu.style';
import { MENU_ITEMS, MenuItem } from './menuItems';
// Redux
import { ReducerState } from './../../../redux/modules';
import { actions as SlidingRightPanelActions } from '../../../redux/modules/uistates';
// Google Analytics
import { TriggerGoogleAnalytics4Tag } from '../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

const drawerWidth = 260;
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: "flex"
		},
		isResponsiveOpen: {
			'@media(max-width: 1200px)': {
				boxShadow: '10px 0 20px 0px rgba(0,0,0,0.1)',

				'& .MuiDrawer-docked': {
				},
			}
		},
		drawerBurger: {
			display: 'none',
			'@media(max-width: 1200px)': {
				display: 'block',
				position: 'absolute',
				left: 22,
				top: '1.7rem',
				margin: 'auto',
				zIndex: 99
			}
		},
		drawerBurgerClose: {
			display: 'none',
			'@media(max-width: 768px)': {
				display: 'block',
				position: 'absolute',
				right: '1rem',
				top: '1rem',
				margin: 'auto',
				zIndex: 99
			}
		},
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
			whiteSpace: "nowrap",
			'& .MuiDrawer-paperAnchorDockedLeft': {
				borderRight: 'none',
			},
			'& .MuiDrawer-root .MuiDrawer-paperAnchorDockedLeft': {
				'@media(max-width: 1200px)': {
					position: 'fixed',
					boxShadow: '10px 0 20px 0px rgba(0,0,0,0.1)'
				}
			},
			'@media(max-width: 1200px)': {
				//left: -drawerWidth,
				position: 'absolute'
			}
		},
		drawerIcon: {
			'@media(max-width: 768px)': {
				display: 'none'
			}
		},
		drawerOpen: {
			width: drawerWidth,
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
			'& .drawerLogo': {
				width: '100%',
				display: 'block',
				'@media(max-width: 768px)': {
					// added to match the mobile view which is for all brands
					display: 'none'
				}
			},
			'@media(max-width: 1200px)': {
				width: 260,
				boxShadow: '10px 0 20px 0px rgba(0,0,0,0.1)'
			},
			'& [data-tooltip]::after, &[data-tooltip]::before': {
				display: 'none',
			},
		},
		drawerClose: {
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			'& .drawerLogo': {
				width: 'auto',
				display: 'block'
			},
			overflowX: "hidden",
			width: `calc(${theme.spacing(5)} + 1px)`,
			[theme.breakpoints.up("xs")]: {
				width: `calc(${theme.spacing(10)} + 1px)`,
			},
			'@media(max-width: 768px)': {
				width: 0
			},
			'@media(hover: hover) and (pointer: fine)': {
				'& [data-tooltip]::after, &[data-tooltip]::before': {
					display: 'block'
				},
				'& [data-tooltip][data-flow^="right"]::after': {
					top: 'auto',
					left: 100,
					marginTop: -24,
				},
				'& [data-tooltip][data-flow^="right"]::before': {
					top: 'auto',
					left: 97,
					right: 'auto',
					marginTop: 24,
				}
			},

		},
		toolbar: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			padding: theme.spacing(0, 1),
			paddingTop: 30,
			// necessary for content to be below app bar
			...theme.mixins.toolbar,
			'@media(max-width: 768px)': {
				minHeight: 10,
				"& > div": {
					display: 'none'
				},
			}
		},
		toolbarClosed: {
			flexDirection: 'column-reverse',
			justifyContent: 'center',
			minHeight: 120,
			paddingTop: 15,
			'@media(max-width: 768px)': {
				minHeight: 10,
				"& > div": {
					display: 'none'
				},
			}
		},
		content: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
		label: {
			fontWeight: "normal",
			"&:hover, &:active": {
				fontWeight: "bold",
			},
		},
		responsiveBtns: {
			display: 'none',
			'@media(max-width: 768px)': {
				display: 'block',
				//to remove the collapsing of register a client and send registration link buttons
				// position: 'absolute',
				width: '100%',
				bottom: 0,
				left: 0
			}
		},
		responsiveButton: {
			width: '100%',
			margin: '0 auto 1.25rem',
			display: 'block',
			maxWidth: 220,
		},
		registrationLinkButton: {
			color: "#2D91E9",
			border: "1px solid #E8E8E8",
			background: "#FFF",
			"&:hover": {
				background: "#FFF",
				border: "1px solid #2D91E9",
			},
		},
	})
);

function APSlidingMenu(props: any) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(true);
	const { translate, navigate, roleAccessFunction } = props;

	const {
		VIEW_ACCOUNT,
		VIEW_CLIENT_MANAGEMENT,
		VIEW_INVOICES,
		VIEW_COMMISSION,
		REFER_CLIENT,
		VIEW_REFERRALS,
		VIEW_RESOURCES,
		VIEW_SETTINGS
	} = roleAccessFunction;

	const roleAccessMap = {
		account: VIEW_ACCOUNT,
		referAClient: REFER_CLIENT,
		clientManagement: VIEW_CLIENT_MANAGEMENT,
		resources: VIEW_RESOURCES,
		referrals: VIEW_REFERRALS,
		commissions: VIEW_COMMISSION,
		invoices: VIEW_INVOICES,
		settings: VIEW_SETTINGS
	};

	const handleMenuClick = (item: MenuItem) => {
		TriggerGoogleAnalytics4Tag(
			GoogleAnalytics4Tags.menuClicks.name,
			GoogleAnalytics4Tags.eventAction.click,
			item.gaTag
		);
	};

	const [isResponsiveOpen, setIsResponsiveOpen] = React.useState(false);

	const toggleResponsiveDrawer = () => {
		setIsResponsiveOpen(!isResponsiveOpen);
		setOpen(!open);
	};

	// Window size
	const [dimensions, setDimensions] = React.useState({
		height: window.innerHeight,
		width: window.innerWidth
	});

	React.useEffect(() => {

		function handleResize() {
			// Set window width/height to state
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}

		// Add event listener
		window.addEventListener("resize", handleResize);

		handleResize();

		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", handleResize);

	}, []);

	React.useEffect(() => {
		if (dimensions.width <= 1200) {
			setOpen(false);
		}
	}, [dimensions]);

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	const resDrawerClass = classnames(classes.root, {
		[classes.isResponsiveOpen]: isResponsiveOpen
	});

	const handleReferralClick = (e) => {
		e.preventDefault();
		toggleResponsiveDrawer();
		props.toggleSlidingRightPanelStatus(true, 'referralForm');
	}

	const MakeReferral = (e) => {
		e.preventDefault();
		navigate('/refer')
	}

	// Responsive Sidebar - When open below 1200px should be able to click outside and will close - enabled esc kek close as well.
	const containerRef = React.useRef<any>(null);
	const handleClickOutside = (e) => {
		//e.preventDefault();
		let refCurrent = containerRef.current;
		if (dimensions.width <= 1200 && open && refCurrent && !refCurrent.contains(e.target)) {
			setOpen(false);
		}
	};

	const escFunction = (e) => {
		if (e.keyCode === 27 && dimensions.width <= 1200 && open) {
			e.preventDefault();
			setOpen(false);
		}
	};

	React.useEffect(() => {
		let isCancelled = false;
		if (!isCancelled) {
			document.addEventListener("mousedown", handleClickOutside);
			document.addEventListener("keydown", escFunction, false);
		}
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
			document.removeEventListener("keydown", escFunction, false);
			isCancelled = true;
		};
	});

	return <>
		<IconButton
			className={classes.drawerBurger}
			onClick={toggleResponsiveDrawer}
			size="large">
			<BurgerIcon />
		</IconButton>

		<div className={resDrawerClass} ref={containerRef}>
			<Drawer
				onClose={toggleResponsiveDrawer}
				variant="permanent"
				className={clsx(classes.drawer, {
					[classes.drawerOpen]: open,
					[classes.drawerClose]: !open,
				})}
				classes={{
					paper: clsx({
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open,
					}),
				}}
			>
				<div className={clsx(classes.toolbar, { [classes.toolbarClosed]: !open })}>

					<IconButton
						className={classes.drawerBurgerClose}
						onClick={toggleResponsiveDrawer}
						size="large">
						<CloseIcon />
					</IconButton>

					<Link className="drawerLogo" to={VIEW_ACCOUNT ? '/account' : '/client_management'}>
						<APLogo open={open} />
					</Link>

					{open ? (
						<IconButton className={classes.drawerIcon} onClick={handleDrawerClose} size="large">
							<CollapseIcon />
						</IconButton>
					) : (
						<IconButton
							data-testid='drawerOpen'
							className={classes.drawerIcon}
							onClick={handleDrawerOpen}
							size="large">
							<ExpandIcon />
						</IconButton>
					)}
				</div>
				{open ? <APContactSection /> : <APContactSectionClosed />}
				<List aria-label="Main Navigation">
					{MENU_ITEMS.map((item: MenuItem) => {
						const hasAccess: boolean | null = roleAccessMap[item.type] ?? true;

						return hasAccess ? (
							<ListItemLink
								key={item.label}
								to={item.route}
								drawerOpen={open}
								primary={translate(item.label)}
								icon={item.icon}
								onMenuClick={handleMenuClick}
								item={item}
							/>
						) : null;
					})}
				</List>

				<div className={classes.responsiveBtns}>
					<APButton
						className={classes.responsiveButton}
						variant="contained"
						onClick={handleReferralClick}
						color={"primary"}
					>
						{translate('header.action.send.registration.link')}
					</APButton>
					<APButton
						className={classes.responsiveButton}
						variant="contained"
						onClick={MakeReferral}
						color="primary"
					>
						{translate('header.action.make.referral')}
					</APButton>
				</div>
			</Drawer>
		</div>
	</>;
}

const mapStateToProps = (store: ReducerState) => ({
	affiliateDetails: store.user.affiliateDetails,
	roleAccessFunction: store.user.roleAccessFunction
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	toggleSlidingRightPanelStatus: SlidingRightPanelActions.toggleSlidingRightPanelStatus,
}, dispatch);

export default (
	withNavigation(withTranslate(
		withStyles(APSlidingMenuStyles)(
			connect(mapStateToProps, mapDispatchToProps)(APSlidingMenu)
		)
	))
);
